import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MaterialModule } from '../material/material.module';
import { ConnectionErrorDialogComponent } from './components/connection-error-dialog/connection-error-dialog.component';
import { FormElementClassDirective } from './directives/form-element-class.directive';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, ConnectionErrorDialogComponent, FormElementClassDirective],
  imports: [CommonModule, MaterialModule],
  exports: [HeaderComponent, FooterComponent,FormElementClassDirective],
})
export class SharedModule {}
